import React, { Component } from 'react';
import Select from 'react-select'

import { isEmpty } from 'lodash';
import PopUp from '../../../../commonModules/interface/PopUp';
import FormCommercialReturn from './FormCommercialReturn';
import Spin from '../../../../commonModules/interface/Spin';
import { TableRow, TableCell, Table, TableBody, IconButton, Button } from '@material-ui/core';
import { CloseRounded } from '@material-ui/icons';
import { TableLayout } from '../containers/Layout';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline.jsx';
import ProductLineCell from '../containers/ProductLineCell';
import { toast } from 'react-toastify';
import { generateUniqueId } from '../../../../commonModules/utils/statsFunctions';

const initErrors = {
    shop_id: "",
    commercial_id: "",
    products:[
        {
            product_id:"",
            quantity:"",
        }
    ],
}

const initSale = {
    shop_id: "",
    shopDisplay:{},
    commercial_id: "",
    commercialDisplay:{},
    products:[
        {
            display:{value:"", label:""},
            product_id:"",
            quantity:"",
            max:"",
            stock_id:"",
        }
    ],
}

class Form extends Component {
    state = { 
        rea: initSale,
        errors: initErrors,
        view: "rea",
        numberProd:1,
        stocks: [],
        unique_id: generateUniqueId(),
        sending: false,
        form: <div></div>  // Liste des produits
    }

    // fetchCommercialStocks = async (commercialID) => {
    //     let stocks = []
    //     const { PRODUCTS, COMMERCIAL_STOCKS } = this.props;
    //     if( !isEmpty(COMMERCIAL_STOCKS[commercialID]) ) {

    //         COMMERCIAL_STOCKS[commercialID].map( stock => {
    //             stock.product = PRODUCTS[stock.product_id]
    //             stocks.push(stock)
    //         })
    //     }
    //     return stocks
    // }

    fetchCommercialStocks = async (commercialID) => {
        let stocks = []
        const { AGENTS, PRODUCTS } = this.props;
        if( isEmpty(AGENTS[commercialID].stocks) ) {
            try {
                const response = await fetch('/stocks/commercial/agent/stockList',{
                    method:'POST',
                    headers: { 
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                    },
                    body: JSON.stringify({ commercialID }),
                    credentials: 'same-origin',
                }); 
                
                const list = await response.json()
                console.log(list)// list returns new object created
                if(list.error){ // no errors, return new Object
                    console.log("error list fetched", list.error)
                
                } else {
                    stocks = list.map( stock => {
                        stock.product = PRODUCTS[stock.product_id]
                        return stock
                    })
                }
                
            } catch (err) {
                console.log("catch error", err)
            }

        // } else {
        //     stocks = AGENTS[commercialID].stocks
        }

        return stocks
        
    }

    handleSelect = async (option, name) => { 
        console.log("COM REAPPRO SELECT HANDLE",{option, name});

        let value = option.value
        let displayName = name === "shop_id" ? "shopDisplay" : "commercialDisplay"
        // console.log("change shop");
        if (name == "shop_id"){
            this.setState({
                ...this.state,
                rea:{
                    ...this.state.rea,
                    [name]:value,
                    [displayName]:option,
                    products:[ // reset products array to prevent stock errors
                        {
                            display:{value:"", label:""},
                            product_id:"",
                            quantity:"",
                            max:"",
                            stock_id:"",
                        }
                    ],
                },
                numberProd:1
            }, () =>{
                // Organise la visualisation des produits
                this.createAddForm()
            }) 

        } else {
            this.setState({
                ...this.state,
                rea:{
                    ...this.state.rea,
                    [name]:value,
                    [displayName]:option,
                }
            })
            // fetch commercial stocks
            let stocks = await this.fetchCommercialStocks(value)
            this.setState({
                ...this.state,
                numberProd:1,
                rea:{
                    ...this.state.rea,
                    products:[{
                        display:{},
                        product_id:"",
                        quantity:"",
                        max:"",
                        stock_id:"",
                    }],
                },
                errors:initErrors,

                stocks,
            }, () =>{
                // Organise la visualisation des produits
                this.createAddForm()
            }) 
        }
           
    }
    handleSelectProducts = (option, index) => {
        // console.log("SELECT HANDLE",{option, index});

        let value = option.value
        const max = this.findMax(value)    

        let cpProducts = this.state.rea.products
        cpProducts[index].product_id = value
        cpProducts[index].max = max[0]
        cpProducts[index].stock_id = max[1]
        cpProducts[index].display = option
        
        this.setState({
            ...this.state,
            rea:{
                ...this.state.rea,
                products:cpProducts,
            }
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        })         
    }

    findMax = (product_id, list = this.state.stocks) => { // return available stock and it's id
        let max = 0
        let stock_id = ""

        list.map( stock => {            
            if( stock.product.id === product_id ){    
                max = stock.quantity
                stock_id = stock.id
                return                    
            }
        })   

        return [max, stock_id]
    }
    
    createProductList = () => {
        const { stocks } = this.state;
        const list = [{value:"", label:"Chosissez un Produit"}]

        if( !isEmpty(stocks) ){
            stocks.map( stock => {   
                let selected = false
                this.state.rea.products.map( prod => {   
                    if( prod.product_id  === stock.product.id)   {  // already selected   
                        selected = true 
                    } 
                })
                if( stock.quantity > 0 ){
                    list.push ({
                        value: stock.product.id, 
                        label: `${stock.product.marque} - ${stock.product.name}`, 
                        disabled: selected
                    })
                }
            })
        }
        return list
    }

    createAddForm = () => {
        const tab = []
        const products = this.createProductList()
        const shop_id = this.state.rea.shop_id
        if (shop_id === ""){
            return
        }
        const commercial_id = this.state.rea.commercial_id
        if (commercial_id === ""){
            return
        }
        // console.log("[INFO] CREATE ADD FORM INDEX ");
        for (let i = 0; i < this.state.numberProd;i++) {
            
            tab.push(
                <TableRow key={i}>
                    <ProductLineCell
                        numberProd={this.state.numberProd}
                        handleDeleteProd={() => this.handleDeleteProd(i)}
                        options={products}
                        value={this.state.rea.products[i].display || {value:"", label:""}}
                        onChange={ option => this.handleSelectProducts(option,i)}
                        error={this.state.errors.products[i].product_id}
                    />
                    <TableCell className="text-center" style={{width: "150px"}}>
                        <InputText 
                            type="number" 
                            min={1} 
                            max={this.state.rea.products[i].max} 
                            step={10} 
                            onChange={this.handleChange} 
                            value={this.state.rea.products[i].quantity} 
                            name={"prod_-quantity-"+i} 
                            label="Quantité"
                            error={this.state.errors.products[i].quantity}
                            helperText={this.state.rea.products[i].max ? "Disponible : "+ this.state.rea.products[i].max :"" }
                        />
                    </TableCell>
                </TableRow>                                        
            )
        }
        this.setState({
            ...this.state,
            form:tab,
        })
        return tab;
    }
    handleAddProd = () => {// must add new line in the form to add a product to the rea
        const shop_id = this.state.rea.shop_id
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        const commercial_id = this.state.rea.commercial_id
        if (commercial_id === ""){
            toast.error("Commercial must be selected")
            return
        }
        console.log("handleAddProd ComReturn  ",shop_id,"-",commercial_id)
        
        this.setState({
            ...this.state,
            rea:{
                ...this.state.rea,
                products:[
                    ...this.state.rea.products,{
                    display:{},
                    product_id:"",
                    quantity:"",
                    max:"",
                    stock_id:"",
                }]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products,{                      
                    product_id:"",
                    quantity:"",
                    
                }]
            },
            numberProd:this.state.numberProd+1,
            
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        })    
    }
    handleAddProdByCSV = (productList) =>{
        console.log("Form Rea COM F  ,handleAddProdByCSV,",productList)
        const productListLocal = new Array();
        const productListLocalErr = new Array();
        const shop_id = this.state.rea.shop_id
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        const commercial_id = this.state.rea.commercial_id
        if (commercial_id === ""){
            toast.error("Commercial must be selected")
            return
        }
        let nbOfProduct = 0;

        productList.forEach((value, key)=>{
            console.log("Form Rea  COM F ,handleAddProdByCSV,",value[5],value[4])
            if (!value[4]){
                return
            }
            const max = this.findMax(value[5].id, shop_id)    
            const maxProductNumber =  max[0]
            const stock_id = max[1]
           
            if (stock_id ==="" || typeof stock_id === "undefined"){
                toast.error( "Produit '"+ value[5].name+ "' pas disponible dans le magasin")
                return
            }
            if (maxProductNumber<value[2]) {
                toast.error( "Produit '"+ value[5].name+ "' pas de quantite suffisante dans le magasin")
                return
            }
            nbOfProduct++
             const productEntry = {
                display: {value:value[5].id,label:value[0]},
                product_id: value[5].id,
                quantity: value[2],
                max: maxProductNumber,
                stock_id: stock_id,
              };
            const productEntryErr = {                      
                product_id:"",
                quantity:"",
            };
            productListLocal.push(productEntry);
            productListLocalErr.push(productEntryErr);
        })
        console.log("Form Rea COM ,handleAddProdByCSV,productListLocal",productListLocal)
        if (productListLocal.length > 0){
            console.log("Form Rea COM,handleAddProdByCSV,Add product",productListLocal.length)
            this.setState({
                ...this.state,
                rea:{
                    ...this.state.rea,
                    products:[...productListLocal]
                },
                errors:{
                    ...this.state.errors,
                    products:[...productListLocalErr]
                },
                numberProd:nbOfProduct,
            }, () =>{
                this.createAddForm()
            })  
        }
        toast.info( "Importation réussi de "+nbOfProduct+" produits")
    }
    handleDeleteProd = (index) => {
        this.setState({
            ...this.state,
            rea:{
                ...this.state.rea,
                products:[
                    ...this.state.rea.products.slice(0,index),
                    ...this.state.rea.products.slice(index +1),
                ]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products.slice(0,index),
                    ...this.state.errors.products.slice(index +1),   
                ]
            },
            numberProd:this.state.numberProd - 1,
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        })    
    }
    handleChange = (e) => {  
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        
        if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" || "prod_-product_id-4"

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            // console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            let cpProducts = this.state.rea.products
            cpProducts[index][name] = value
            if(name === "quantity" ) {   
                if(value === "" || regex.test(value)){// update value only if its a int
                this.setState({
                        ...this.state,
                        rea:{
                            ...this.state.rea,
                            products:cpProducts,
                        }
                    }, () =>{
                        // Organise la visualisation des produits
                        this.createAddForm()
                    }) 
                }
                
            } else {
                this.setState({
                    ...this.state,
                    rea:{
                        ...this.state.rea,
                        products:cpProducts,
                    }
                }, () =>{
                    // Organise la visualisation des produits
                    this.createAddForm()
                }) 
            }
                    
        } else {
            this.setState({
                ...this.state,
                rea:{
                    ...this.state.rea,
                    [field]:value
                }
            }, () =>{
                // Organise la visualisation des produits
                this.createAddForm()
            }) 
        }
    }
    validate = () => {
        let noErrors = true
        let errors = this.state.errors

        const rea = Object.assign({}, this.state.rea)
        Object.keys(rea).map( field => {
            console.log(field);
            
            if( isEmpty(rea[field]) && !rea[field]) {// input is empty  
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
                    
            } else if( field === "products" ) {
                rea.products.map( (item, j) => {
                    Object.keys(item).map( field2 => { // field2 product_id || quantity
                        
                        if(field2 === "max" ){
                            errors.products[j][field2] = ""
                        } else if(item[field2] === "" || item[field2] === 0 || item[field2] === "0"){
                            noErrors = false
                            errors.products[j][field2] = "Veuillez remplir ce champ"
                        } else if(parseInt(item.max) < parseInt(item.quantity)){
                            noErrors = false
                            errors.products[j].quantity = "Stock insuffisant"
                        } else {
                            errors.products[j][field2] = ""
                        }
                    })
                })

            } else {// not empty
                errors[field] = ""   
            }
        })
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            ...this.state,
            errors : errors
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        }) 
        if(noErrors){
            this.setState({
                view: "confirm"
                // view : "client"
            })
        } else {// !VALIDATE
            toast.error( "Le formulaire contient des erreurs")
        }
        
        // return noErrors
    }


    handleSubmit = async () => {
        let newRea = Object.assign({}, this.state.rea)
        // rea.id = ""
        // newRea.date = new Date()
        newRea.nature =  "commercial_return"
        newRea.unique_id =  this.state.unique_id

        for (let i = 0; i < newRea.products.length; i++){
            newRea.products[i].quantity = parseInt(newRea.products[i].quantity)                      
        }
        console.log('====================================');
        console.log({newRea});
        console.log('====================================');
        await this.props.createCommercialReturn(newRea)
            
        if(this.props.STATE.commercialReturns.error){
            console.log("ERROR", this.props.STATE.commercialReturns.error);
            this.setState({
                sending: false,
            }, () =>{
                // Organise la visualisation des produits
                this.createAddForm()
            }) 
            toast.error( this.props.STATE.commercialReturns.error)
        } else {
            //success 
            this.setState({
                sending: false,
            }, () =>{
                // Organise la visualisation des produits
                this.createAddForm()
            }) 
            toast.info("Opération enregistrée avec succès")
            this.clearForms()                        
            this.props.handleClose()
        }                
    }
    clearForms = () => {
        this.setState({
            numberProd:1,
            
            rea:initSale,
            errors:initErrors,
            
        })
    }

    render() {
        const { view } = this.state;
        console.log("[STATE] NEW return comm FORM ",this.state.rea);

        const fieldList = [
            {name: "shop_id", label:"Shop", display:this.state.rea.shopDisplay.label},
            {name: "commercial_id", label:"Commercial", display:this.state.rea.commercialDisplay.label},
            {name: "products"},   
            // {name: "total", label:"Montant Total", display:this.state.rea.total},
        ]
 
        return (
            <React.Fragment>
                {this.props.STATE.commercialReturns.fetching && <Spin />}

                {view === "rea" &&
                    <div>
                        <h5>Formulaire Reappro Commercial</h5>
                        <FormCommercialReturn 
                            {...this.state} 
                            {...this.props} 
                            handleSelect={this.handleSelect}
                            createAddForm={this.state.form}
                            handleAddProd={this.handleAddProd}
                            handleAddProdByCSV={this.handleAddProdByCSV}
                            handleChange={this.handleChange}
                            validate={this.validate}
                            handleClose={this.props.handleClose}
                        />
                    </div>
                }
                
                {view === "confirm" &&
                <PopUp 
                    title="Résumé" 
                    close={() => this.setState({view: "rea"})}
                    submitAction = {this.handleSubmit}
                    submitTitle="Valider"
                >
                    <TableLayout>
                        <TableBody>
                        {fieldList.map( field => {
                            if(this.state.rea[field.name]){
                                if (field.name === "products"){
                                    return this.state.rea.products.map( prod => (
                                        <TableRow key={prod.product_id}>
                                            <TableCell>{prod.display.label}</TableCell>
                                            <TableCell>{prod.quantity}</TableCell>
                                        </TableRow>
                                    ))
                                } else {
                                    return (
                                        <TableRow key={field.label} >
                                            <TableCell>{field.label}</TableCell>
                                            <TableCell colSpan={3}>{field.display}</TableCell>
                                        </TableRow>
                                    )
                                }
                            } 
                        })

                        }                            
                        </TableBody>
                    </TableLayout>
                </PopUp>
                }
            </React.Fragment>
        );
    }
}

export default Form;